var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{attrs:{"show":_vm.notEmpty,"variant":"info"},domProps:{"innerHTML":_vm._s(_vm.translated)}})
}
var staticRenderFns = []

export { render, staticRenderFns }